export interface TicketStatus {
    active: 1;
    close: 2;
}

export const TicketStatusID: TicketStatus = {
    active: 1,
    close: 2,
};

export interface TicketData {
    ticket_id: number;
    ticket_status: number;
    ticket_type: string;
    register_id: number;
    user_id: number;
    fullname: string;
    phone_contact: number;
    phone_whatsapp: string;
    email: string;
    notify_flag: number;
    exposure: number;
    note_content: string;
    note_updated_at: Date;
    note_updated_by: number;
    note_updated_by_fullname: string;
    attention_id: number;
    typification_id: number;
    assigned_user_id: number;
    recommendation_id: number;
    user_size: number;
    campaign: string;
    user_type: number;
}
